import React from 'react';
import { useLocation } from 'react-router-dom';
import { isSystemDevZonePath } from '../constants/systemDevZone';
import './DevZoneFooter.css';

const DevZoneFooter = () => {
  const { pathname } = useLocation();

  if (!isSystemDevZonePath(pathname)) {
    return null;
  }

  return (
    <footer className="dev-zone-footer" role="note">
      Geliştirici alanı — lütfen buraya dokunmayın. Bu sayfalar yalnızca yerel test ve sistem
      bakımı içindir.
    </footer>
  );
};

export default DevZoneFooter;
